import { combineReducers } from 'redux';
import auth from './authReducer';
import lbox from './lboxReducer'

export default combineReducers({
   auth,
   lbox
  });

  